import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonBadge: {
    width: pixelDimensions(25),
    height: pixelDimensions(8),
    marginBottom: pixelDimensions(5),
    justifyContent: 'center',
    backgroundColor: Colors.blueGrey600,
  },
  buttonBadgeSelected: {
    backgroundColor: appColors.primary,
  },
  check: {
    backgroundColor: Colors.white,
    borderColor: Colors.white,
    width: pixelDimensions(40),
  },
  viewBase: {
    flex: 1,
  },
  scroll: {
    marginHorizontal: pixelDimensions(1.75),
  },
  cardCalendar: {
    borderRadius: pixelDimensions(2),
  },
  TitleCalendar: {
    fontFamily: 'MBold',
    fontSize: pixelDimensions(4.5),
    textAlign: 'center',
    padding: pixelDimensions(1.5),
    marginTop: pixelDimensions(1),
    marginBottom: pixelDimensions(2),
  },
  card: {
    padding: pixelDimensions(3),
    marginTop: pixelDimensions(5),
    borderRadius: pixelDimensions(2),
  },
  cardContent: {
    alignItems: 'center',
  },
  groupButtonsHours: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  buttonHour: {
    backgroundColor: Colors.blueGrey600,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  buttonHourSelected: {
    backgroundColor: appColors.primary,
    padding: pixelDimensions(1.25),
    margin: pixelDimensions(1.25),
    borderRadius: pixelDimensions(7),
  },
  textButtonHour: {
    fontSize: Dimensions.get('window').width < 800 ? pixelDimensions(3.25) : pixelDimensions(2),
    fontWeight: '100',
    color: 'white',
  },
  nextButton: {
    paddingVertical: pixelDimensions(3),
    alignItems: 'center',
  },
  nextButtonDisabled: {
    backgroundColor: appColors.primary,
    opacity: 0.6,
  },
  textBadge: {
    color: Colors.white,
    fontFamily: 'MBold',
    textAlign: 'center',
    fontSize: pixelDimensions(4),
    paddingHorizontal: pixelDimensions(2),
  },
  textBadgeSelected: {
    color: appColors.primary,
  },
  textSubTitle: {
    marginHorizontal: pixelDimensions(5),
    fontSize: pixelDimensions(4),
  },
  textCheck: {
    fontFamily: 'MRegular',
    fontSize: pixelDimensions(4.5),
    marginLeft: pixelDimensions(2),
  },
});

export const themeCalendar = {
  selectedDayBackgroundColor: appColors.primary,
};

export default styles;
